import tinyColor from 'tinycolor2';

export default class ColourService {
	public static getContrastingColour(colour: string) {
		const contrastingColour = '#ffffff';

		if (!colour) {
			return contrastingColour;
		}

		if (tinyColor(colour).isLight()) {
			return '#212121';
		}

		return contrastingColour;
	}

	public static darken(colour: string, amount: number): string {
		const newColour = tinyColor(colour);
		newColour.darken(amount);
		return newColour.toHexString();
	}

	public static setAlphas(colours: string[], amount: number): string[] {
		return colours.map(colour => ColourService.setAlpha(colour, amount));
	}

	public static setAlpha(colour: string, amount: number): string {
		const newColour = tinyColor(colour);
		newColour.setAlpha(amount);
		return newColour.toRgbString();
	}
}
